import { zetApi } from '@zet/network'

import ENDPOINTS from '../../endpoints'

export async function resendOtp(hash: string) {
  const response = await zetApi.request({
    url: ENDPOINTS.resendOtp.endpoint,
    method: ENDPOINTS.resendOtp.method,
    headers: {
      hash: encodeURIComponent(hash),
    },
  })

  return response.data.data
}
